// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p a[data-v-3e9bec44] {\n  padding-top: 10px;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
